import axios from "axios";
import { requestPostApiCall, requestGetApiCall } from "./ApiServices";
const baseUrl = process.env.REACT_APP_API_ADMIN_URL;
//------------------------- LOGIN USER -------------------------//
export const loginUser = async (loginData, callback) => {
  const urlEndPoint = "login";
  const payload = {
    email: loginData.login,
    password: loginData.password,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------- REGISTER USER -------------------------//
export const rgisterUser = async (formData, callback) => {
  const selectedPurposes = formData.purpose.join("&purpose=");
  const urlEndPoint = `register?purpose=${selectedPurposes}`;
  const payload = new FormData();
  payload.append("firstName", formData.firstName);
  payload.append("lastName", formData.lastName);
  payload.append("mobileNumber", formData.mobileNumber);
  payload.append("email", formData.email);
  payload.append("role", formData.role);
  payload.append("password", formData.password);
  payload.append("profile", formData.profile);
  payload.append("purpose", JSON.stringify(formData.purpose));
  if (formData.ID_card) {
    payload.append("ID_card", formData.ID_card);
  }

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------- USER PROFILE -------------------------//
// export const userProfile = async (formData, callback) => {
//   const userId = formData.user_id;
//   //   console.log("print " + userId);
//   const urlEndPoint = `profile/${userId}`;

//   await requestGetApiCall(urlEndPoint, {}, callback);
// };

export const userProfile = async (callback) => {
  const urlEndPoint = `profile`;
  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- PENDING USERs -------------------------//
export const pendingUsers = async (callback) => {
  const urlEndPoint = `admin/pending_users`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- APPROVED USERS -------------------------//
export const approvedUsers = async (callback) => {
  const urlEndPoint = `admin/approved_users`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- REJECTED USERS -------------------------//
export const rejectedUsers = async (callback) => {
  const urlEndPoint = `admin/rejected_users`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- APPROVE USER -------------------------//
export const approveUser = async (formData, callback) => {
  const userId = formData.user_id;
  const urlEndPoint = `admin/approve/${userId}`;
  const payload = {
    userId: formData.user_id,
    licensekey: formData.licenseKey,
    start_date:formData.start_date,
    end_date:formData.end_date
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------- REJECT USER -------------------------//
export const rejectUser = async (formData, callback) => {
  const userId = formData.user_id;
  const urlEndPoint = `admin/reject/${userId}`;

  await requestPostApiCall(urlEndPoint, {}, callback);
};

//---------------------LICENSE KEY FETCHING ----------------------//
export const getLicenseKey = async (formData, callback) => {
  const userId = formData.user_id;
  const urlEndPoint = `admin/licensekey/${userId}`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- GET ALL USER -------------------------//
export const getAllUsers = async (callback) => {
  const urlEndPoint = `admin/all_users`;
  const params = {
    status: "",
  };

  await requestGetApiCall(urlEndPoint, params, callback);
};

//------------------------- UPLOAD MEDIA -------------------------//
export const uploadMedia = async (formData, callback) => {
  const urlEndPoint = `upload_video/`;

  // Create FormData to handle file uploads
  const payload = new FormData();
  payload.append("title", formData.title);
  payload.append("inputfile_type", formData.inputfile_type);
  payload.append("description", formData.description);
  payload.append("tags", JSON.stringify(formData.tags)); // Ensure it's JSON stringified
  payload.append("views", formData.views);
  payload.append("uploader", formData.uploader);
  payload.append("thumbnail", formData.thumbnail); // Appending file
  payload.append("video", formData.video); // Appending file
  payload.append("publish", formData.publish);

  try {
    // Await the response from the request
    const response = await requestPostApiCall(urlEndPoint, payload);

    // Check if callback is passed and is a function, then pass the response
    if (callback && typeof callback === "function") {
      callback(response);
    }

    // Return response to allow further processing in handleSubmit
    return response;
  } catch (error) {
    const errorMessage = {
      status: "error",
      message: "Error uploading Media.",
      code: error.response ? error.response.status : 500,
    };

    // If callback is provided, pass the error message to the callback
    if (callback && typeof callback === "function") {
      callback(errorMessage);
    }

    // Return error to allow processing in handleSubmit
    return errorMessage;
  }
};

//------------------------- PENDING VIDEO REQUESTS -------------------------//
export const pendingVideoRequests = async (callback) => {
  const urlEndPoint = `admin/pending_video_requests/`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- APPROVED VIDEO REQUESTS -------------------------//
export const approvedVideoRequests = async (callback) => {
  const urlEndPoint = `admin/approved_video_requests/`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- REJECTED VIDEO REQUESTS -------------------------//
export const rejectedVideoRequests = async (callback) => {
  const urlEndPoint = `admin/rejected_video_requests/`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- APPROVE VIDEO REQUESTS -------------------------//
export const approveVideo = async (formData, callback) => {
  const urlEndPoint = `admin/approve_video_request/`;
  const payload = {
    video_id: formData.videoId,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------- REJECT VIDEO REQUESTS -------------------------//
export const rejectVideo = async (formData, callback) => {
  const urlEndPoint = `admin/reject_video_request/`;
  const payload = {
    video_id: formData.videoId,
    remarks: formData.remarks,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------ DELETE VIDEO ----------------------------------//

export const deleteVideo = async (formData, callback) => {
  console.log("videoid", formData.video_id);
  const urlEndPoint = `deleteVideo/`;
  const payload = {
    video_id: formData.video_id,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------- ALL VIDEO REQUESTS -------------------------//
export const allVideos = async (callback) => {
  const urlEndPoint = `admin/fetch_video_request/`;
  const params = {
    videostatus: "",
  };

  await requestGetApiCall(urlEndPoint, params, callback);
};

export const allYouTubeVideos = async (callback) => {
  const urlEndPoint = `learner/videos_request/`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};
//------------------------- FEEDBACK -------------------------//
export const feedback = async (formData, callback) => {
  const urlEndPoint = `feedback/`;

  const payload = {
    user_id: formData.userId,
    video_id: formData.videoId,
    description: formData.description,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//-------------------- TEACHER FEEDBACK -------------------------------//

export const teacherFeedback = async (formData, callback) => {
  const urlEndPoint = `teacher_feedback/`;

  const payload = {
    user_id: formData.userId,
    description: formData.description,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------- ALL USERS FEEDBACK -------------------------//
export const allFeedbacks = async (callback) => {
  const urlEndPoint = `AllFeedbacks/`;

  await requestGetApiCall(urlEndPoint, {}, callback);
};

//------------------------- ALL VIDEOS OF TEACHER -------------------------//
export const teacherVideos = async (formData, callback) => {
  const urlEndPoint = `teacher_media/`;
  const params = {
    // video_id: formData.videoId,
    user_id: formData.user_id,
  };

  await requestGetApiCall(urlEndPoint, params, callback);
};

//------------------------- ALL VIDEOS OF MODERATOR -------------------------//
export const allVideosModerator = async (callback) => {
  const urlEndPoint = `moderater_media/`;

  await requestGetApiCall(urlEndPoint, callback);
};

//------------------------- TOTAL VIEWS OF TEACHER -------------------------//
export const allTeachersViews = async (formData, callback) => {
  //   const urlEndPoint = `total_views/`;

  const urlEndPoint = `teacher_total_views`;
  const params = {
    // video_id: formData.videoId,
    user_id: formData.user_id,
  };

  await requestGetApiCall(urlEndPoint, params, callback);
};

//-------------------------TAGS PERCENTAGE --------------------------------//
export const teacherTagPercentage = async (formData, callback) => {
  const urlEndPoint = `tags_percentage/`;
  const params = {
    // video_id: formData.videoId,
    user_id: formData.user_id,
  };

  await requestGetApiCall(urlEndPoint, params, callback);
};

//------------------------- SEND EMAIL -------------------------//
export const sendEmail = async (recipient, subject, body, callback) => {
  const urlEndPoint = `sendEmail/`;
  console.log("sjbducn", body, subject, recipient);
  const payload = {
    recipient: recipient,
    subject: subject,
    body: body,
  };

  try {
    const response = await requestPostApiCall(urlEndPoint, payload, callback);

    if (callback && typeof callback === "function") {
      callback(response);
    }

    return response; // Return the response for further handling
  } catch (error) {
    console.error("Error sending email:", error);
    if (callback && typeof callback === "function") {
      callback({
        status: "error",
        message: "Error sending email.",
        code: error.response ? error.response.status : 500,
      });
    }
  }
};

//------------------ DOWNLOAD COUNT ---------------------------//
export const downloadCount = async (callback) => {
  const urlEndPoint = `downloadCount`;
  await requestPostApiCall(urlEndPoint, {}, callback);
};

//------------------ DOWNLOAD CHECK ---------------------------//
export const downloadCheck = async (callback) => {
  const urlEndPoint = `downloadCheck/`;
  await requestGetApiCall(urlEndPoint, {}, callback);
};

//-----------------ANAVU VIEWS--------------------------
export const anavuViews = async (formData, callback) => {
  // const userId = formData.user_id;
  const urlEndPoint = `teacher_total_Anavuviews`;
  const payload = {
    user_id: formData.user_id,
  };

  await requestGetApiCall(urlEndPoint, payload, callback);
};

//-----------------Anavu views increment -----------------

export const anavuViewsIncrement = async (formData, callback) => {
  const videoId = formData.video_id;
  const urlEndPoint = `AnavuView/${videoId}`;
  const payload = {
    video_id: formData.video_id,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//----------------REquest new license key ----------------

export const requestNewLicensekey = async (formData, callback) => {
  const userId = formData.user_id;
  const urlEndPoint = `requestNewLicensekey/${userId}`;
  const payload = {
    userId: formData.user_id,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//------------------------- ADD LICENSE KEY -------------------------//
export const addLicenseKey = async (formData, callback) => {
  const userId = formData.user_id;
  const urlEndPoint = `admin/addLicensekey/${userId}`;
  const payload = {
    user_id: formData.user_id,
    licensekey: formData.licensekey,
    start_date: formData.start_date,
    end_date: formData.end_date,
  };

  await requestPostApiCall(urlEndPoint, payload, callback);
};

//-----------------------tags data--------------------------
export const tagInputData = async (callback) => {
  const urlEndPoint = `tags`;
  await requestGetApiCall(urlEndPoint, {}, callback);
};

//-------------get refresh token-----------------------------
export const getRefreshToken=async (old_token)=>{
  try{
    const res=await axios.post(`${baseUrl}renewToken`,{
      token:old_token
    })
    console.log("refresh token called",res.data)
  }catch(error){
    throw(error);
  }
}

//-------------token expiry-----------------------------
export const checkTokenExpiry=async (old_token)=>{
  try{
    const res=await axios.post(`${baseUrl}TokenExpiryCheck_and_Renew`,{
      token:old_token,
      requestedFrom:'web'
    })
    return res.data;
  }catch(error){
    throw(error);
  }
}

